/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access -- TODO external dependency */
import { type RumInitConfiguration } from '@datadog/browser-rum';
import cloneDeepWith from 'lodash-es/cloneDeepWith';

// Adapted from https://docs.datadoghq.com/logs/guide/commonly-used-log-processing-rules/#email-address
// Checks for %40 in place of the "@" symbol, in case the email is URL-encoded (or %2540 if it's double encoded)
const emailRegex =
  // eslint-disable-next-line no-control-regex -- copied from Datadog website
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")(@|%40|%2540)(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;

export const beforeSendDatadog: RumInitConfiguration['beforeSend'] = (event, context) => {
  // Make sure that we are not sending any email addresses to Datadog
  if ((context as any)?.requestInput?.includes?.('email=')) {
    return false;
  }

  if ((context as any)?.requestInput?.match?.(emailRegex)) {
    return false;
  }

  if ((context as any)?.requestInput?.includes?.('[email]=')) {
    return false;
  }

  Object.keys(event).forEach((key) => {
    event[key] = cloneDeepWith(event[key], (value) => {
      if (typeof value === 'string') {
        return value
          .replace(/email=[^&]*/, 'email=REDACTED')
          .replace(/\[email\]=[^&]*/, '[email]=REDACTED')
          .replace(emailRegex, '[REDACTED EMAIL]');
      }

      return undefined;
    });
  });

  return true;
};
